<template>
  <div class="page-view">
    <div class="header-row">
      <div>
        <h2>操作日志</h2>
        <p>记录用户管理、配送员管理和个人中心中的用户资料变更。</p>
      </div>
      <el-button type="primary" plain @click="loadLogs">刷新</el-button>
    </div>

    <div class="brand-card filter-card">
      <div class="toolbar-row">
        <el-input v-model.trim="filters.keyword" placeholder="操作人 / 被操作用户 / 内容 / IP" clearable />
        <el-select v-model="filters.page_name" placeholder="操作页面" clearable>
          <el-option label="用户管理" value="用户管理" />
          <el-option label="配送员管理" value="配送员管理" />
          <el-option label="个人中心" value="个人中心" />
        </el-select>
        <el-select v-model="filters.action_type" placeholder="操作类型" clearable>
          <el-option v-for="item in actionTypes" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-select v-model="filters.target_role" placeholder="被操作角色" clearable>
          <el-option label="超级管理员" value="super_admin" />
          <el-option label="管理员" value="admin" />
          <el-option label="业务员" value="sales" />
          <el-option label="配送员" value="courier" />
        </el-select>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          unlink-panels
        />
        <el-button type="primary" plain @click="handleQuery">查询</el-button>
      </div>
    </div>

    <div class="brand-card table-card">
      <el-table :data="logs" stripe>
        <el-table-column prop="created_at" label="时间" min-width="180" />
        <el-table-column prop="page_name" label="页面" min-width="110" />
        <el-table-column prop="action_type" label="类型" min-width="120">
          <template slot-scope="{ row }">{{ actionText(row.action_type) }}</template>
        </el-table-column>
        <el-table-column label="操作人" min-width="180">
          <template slot-scope="{ row }">
            {{ row.operator_name || row.operator_username || "-" }}
            <span class="muted">/ {{ roleText(row.operator_role) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="被操作用户" min-width="190">
          <template slot-scope="{ row }">
            {{ row.target_name || row.target_username || "-" }}
            <span class="muted">/ {{ roleText(row.target_role) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="action_content" label="内容" min-width="420" show-overflow-tooltip />
        <el-table-column prop="ip" label="IP" min-width="140" />
      </el-table>
      <div class="pager-row">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes"
          :total="total"
          :page-size="pager.page_size"
          :current-page="pager.page"
          :page-sizes="[10, 20, 50]"
          @current-change="onPageChange"
          @size-change="onSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { fetchOperationLogs } from "../api/orders";
import { roleLabel } from "../utils/auth";

const ACTION_LABELS = {
  create_user: "新增",
  update_user: "修改",
  enable_user: "启用",
  disable_user: "停用",
  reset_password: "重置密码",
  audit_courier: "审核",
  unlock_user: "解锁",
  delete_user: "删除",
  update_profile: "修改个人信息",
  change_password: "修改密码",
};

export default {
  data() {
    return {
      filters: {
        keyword: "",
        page_name: "",
        action_type: "",
        target_role: "",
      },
      dateRange: [],
      actionTypes: Object.keys(ACTION_LABELS).map((value) => ({ value, label: ACTION_LABELS[value] })),
      logs: [],
      total: 0,
      pager: { page: 1, page_size: 10 },
    };
  },
  mounted() {
    this.loadLogs();
  },
  methods: {
    async loadLogs() {
      const [created_start, created_end] = this.dateRange || [];
      const { data } = await fetchOperationLogs({
        keyword: this.filters.keyword || undefined,
        page_name: this.filters.page_name || undefined,
        action_type: this.filters.action_type || undefined,
        target_role: this.filters.target_role || undefined,
        created_start: created_start || undefined,
        created_end: created_end || undefined,
        page: this.pager.page,
        page_size: this.pager.page_size,
      });
      this.logs = data.items || [];
      this.total = data.total || 0;
    },
    handleQuery() {
      this.pager.page = 1;
      this.loadLogs();
    },
    onPageChange(page) {
      this.pager.page = page;
      this.loadLogs();
    },
    onSizeChange(size) {
      this.pager.page = 1;
      this.pager.page_size = size;
      this.loadLogs();
    },
    roleText(role) {
      return roleLabel(role);
    },
    actionText(action) {
      return ACTION_LABELS[action] || action || "-";
    },
  },
};
</script>

<style scoped>
.muted {
  color: #8a98ad;
}
</style>
